import { useEffect, useState, useCallback } from 'react';

import ProjectInfo from './ProjectInfo';

import './index.css';

const ProjectsComponent = () => {
    const [ready1, setReady1] = useState(false);
    const [ready2, setReady2] = useState(false);
    const [ready3, setReady3] = useState(false);
    const [pinged, setPinged] = useState(false);
    
    const pingSite = useCallback(async (site, index) => {
        try {
            const res = await fetch(site, {method: 'GET', mode: 'no-cors'});
            if (res) {
                if (index === "0") return setReady1(true);
                if (index === "1") return setReady2(true);
                if (index === "2") return setReady3(true);
            } else {
                setTimeout(() => {
                pingSite(site, index)
                }, 30000);
            };
        } catch (e) {

        }
    }, []);
    
    const pingSites = useCallback(() => {
        const sites = [
          'https://ameriax.org',
          'https://employme.onrender.com/',
          'https://spotspace.onrender.com/'
        ];
      
        for (const index in sites) {
            pingSite(sites[index], index);
        };
    
        setPinged(true);
    }, [pingSite]);
    
    useEffect(() => {
        if (!pinged) pingSites();
    }, [pinged, pingSites]);

    return (
        <section id='projects-title-div' aria-labelledby='projects-heading'>
            <div className='projects-intro'>
                <span>01 / SELECTED WORK</span>
                <h1 id='projects-heading'>Built to be <em>explored.</em></h1>
                <p>A small collection of products, systems, and experiences I brought to life.</p>
            </div>
            <div id='projects-project-container'>
                <ProjectInfo id={0} loaded={ready1}/>
                <ProjectInfo id={1} loaded={ready2}/>
                <ProjectInfo id={2} loaded={ready3}/>
            </div>
        </section>
    );
};

export default ProjectsComponent;
